<template>
  <div>
    <el-upload
      :action="imgurl()"
      list-type="picture-card"
      :headers="headers"
      :limit="999"
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      :on-exceed="limitNum"
      :on-success="handleAvatarSuccess"
      :auto-upload="true"
      :file-list="fileList"
      :disabled='disabled'
    >
      <img v-if="imagesUrl" :src="imagesUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"
        style="height: 148px;width: 148px;line-height:148px !important"></i>
    </el-upload>

  </div>
</template>

<script>
  import {
    getToken
  } from "@/utils/auth";
  import axios from 'axios';

  export default {
    name: "index",
    props: {
      limit: {
        type: Number,
        default: 10
      },
      value: {},
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          if (!value) {
            this.fileList = [];
            this.imagesUrl = "";
            return;
          }

          this.fileList = [{
            uid: "1",
            url: value
          }];
          this.imagesUrl = value;
        }
      },
    },
    computed: {
      headers() {
        return {
          "access-token": this.token // 直接从本地获取token就行
        };
      },

    },
    data() {
      return {
        token: getToken(),
        dialogVisible: false,
        imagesUrl: "",
        fileList: []
      }
    },

    methods: {
      imgurl() {
        return axios.defaults.baseURL + "/common/uploadFile";
      },



      // 文件超出个数限制时的钩子
      limitNum(file, fileList) {},
      //文件上传成功时的钩子,拿到图片路径
      handleAvatarSuccess(res, file, fileList) {
        this.imagesUrl = file.response.data;
        this.fileList = [{
          uid: "1",
          url: file.response.data
        }]
        this.$emit("input", this.imagesUrl)

      },
      // 图片格式要求
      beforeAvatarUpload(file) {
        const isPNG = file.type === "image/png";
        const isJPG = file.type === "image/jpeg";
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isPNG && !isJPG) {
          this.$message.error("Support JPEG and JPG other picture formats!");
        }
        if (!isLt2M) {
          this.$message.error("Upload picture size cannot exceed 2MB!");
        }
        return isPNG || (isJPG && isLt2M);
      }
    }
  }
</script>

<style scoped>
  .avatar {
    width: 148px;
    height: 148px;
    display: block;

  }
</style>
